import { configureStore } from '@reduxjs/toolkit'
import { routerMiddleware } from 'connected-react-router'
import type { History } from 'history'
import type { Store } from 'redux'
import createSagaMiddleware from 'redux-saga'

import saga from './sagas'
import createReducer from './slices'
import { createTransform, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { persistLoginState } from './persistLoginState'

type Reducer = ReturnType<typeof createReducer>

export type GlobalState = ReturnType<Reducer>

type Action = Reducer extends (state: GlobalState, action: infer U) => GlobalState ? U : never

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: ['tracking', 'club', 'commissions', 'agentMetrics', 'executiveMetrics'],
  transforms: [
    createTransform(
      (state: any, key) => (key === 'login' ? persistLoginState(state) : state),
      (state: any) => state,
      { whitelist: ['login'] }
    )
  ]
}

const initStore = (history: History): Store<GlobalState, Action> => {
  const sagaMiddleware = createSagaMiddleware()

  const store = configureStore({
    reducer: persistReducer(persistConfig, createReducer(history)),
    middleware: [sagaMiddleware, routerMiddleware(history)],
    devTools: true
  })

  sagaMiddleware.run(saga)

  return store
}

export default initStore
